// src/utils/numeroALetras.js
// Convierte 1234.56 -> "MIL DOSCIENTOS TREINTA Y CUATRO PESOS 56/100 M.N."
// y para USD -> "MIL DOSCIENTOS TREINTA Y CUATRO DÓLARES 56/100 USD"

const UNIDADES = [
  "", "UN", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE",
  "DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISÉIS", "DIECISIETE",
  "DIECIOCHO", "DIECINUEVE", "VEINTE"
];

const DECENAS = [
  "", "", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA",
  "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"
];

const CENTENAS = [
  "", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS",
  "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"
];

function decenasY(units, tens) {
  if (tens === 0) return UNIDADES[units];
  if (tens === 1) return UNIDADES[10 + units];
  if (tens === 2) return units === 0 ? "VEINTE" : "VEINTI" + UNIDADES[units].toLowerCase();
  const base = DECENAS[tens];
  if (units === 0) return base;
  return base + " Y " + UNIDADES[units];
}

function centenasY(number) {
  if (number === 0) return "";
  if (number === 100) return "CIEN";
  const hundreds = Math.floor(number / 100);
  const tensUnits = number % 100;
  return (CENTENAS[hundreds] + " " + decenasY(tensUnits % 10, Math.floor(tensUnits / 10))).trim();
}

function seccion(number, divisor, singular, plural) {
  const hundreds = Math.floor(number / divisor);
  const remainder = number - hundreds * divisor;
  let words = "";

  if (hundreds > 0) {
    words = hundreds === 1 ? singular : numeroMenorMillon(hundreds) + " " + plural;
  }
  return { words, remainder };
}

function numeroMenorMillon(number) {
  const miles = seccion(number, 1000, "MIL", "MIL");
  let result = "";

  if (miles.words) result = miles.words;
  const hundreds = centenasY(miles.remainder);
  result = (result + " " + hundreds).trim();
  return result || "CERO";
}

function numeroALetrasEntero(number) {
  const millones = seccion(number, 1000000, "UN MILLÓN", "MILLONES");
  let result = "";

  if (millones.words) result = millones.words;
  const restoMillones = millones.remainder;

  const miles = seccion(restoMillones, 1000, "MIL", "MIL");
  if (miles.words) result = (result + " " + miles.words).trim();

  const cientos = centenasY(miles.remainder);
  result = (result + " " + cientos).trim();

  return result || "CERO";
}

const CURRENCY_LABELS = {
  MXN: { entero: "PESOS", sufijo: "M.N." },
  USD: { entero: "DÓLARES", sufijo: "USD" },
};

export function numeroALetras(monto, { currency = "MXN" } = {}) {
  const labels = CURRENCY_LABELS[currency] || CURRENCY_LABELS.MXN;

  const value = Number(monto ?? 0);
  const redondeado = Math.round((value + Number.EPSILON) * 100) / 100;

  const enteros = Math.floor(Math.abs(redondeado));
  const centavos = Math.round((Math.abs(redondeado) - enteros) * 100);

  const textoEnteros = numeroALetrasEntero(enteros);
  const textoCentavos = String(centavos).padStart(2, "0");

  let texto = `${textoEnteros} ${labels.entero} ${textoCentavos}/100 ${labels.sufijo}`;
  if (value < 0) texto = "MENOS " + texto;
  return texto.toUpperCase();
}
